Ext.define('SA.CellsCache', {
    constructor() {
        this.map = new Map();
    },

    getCells() {
        return Array.from(this.map.values());
    },

    purgeStaleEntries() {
        var els = Array.from(this.map.keys());

        els.filter(el => !document.contains(el)).forEach(el => this.map.delete(el));
    },

    setState(el, state) {
        if (!this.map.has(el)) {
            let cell = this.createCell({el});

            this.map.set(el, cell);
        }

        this.map.get(el).setState(state);
    }
});